import MaterialCheckbox from "@mui/material/Checkbox";
import { theme as defaultTheme } from "@mindlercare/ui-web";
import { styled } from "styled-components";

const MaterialCheckboxStyled = styled(MaterialCheckbox)({
  color: defaultTheme.COLORS.GRAY,

  "&.Mui-checked, .MuiCheckbox-colorSecondary.Mui-checked": {
    color: defaultTheme.COLORS.ACTION_BLUE,
  },
});

const Checkbox = (props) => {
  const { ...other } = props;
  return <MaterialCheckboxStyled {...other} />;
};

export default Checkbox;
